import { toggleThemeAction } from "../redux/slices/authSlice";
import { Appbar } from "react-native-paper";
import React from "react";
import { useAppDispatch, useAppSelector } from "../redux/store";

export const ThemeToggle = () => {
  const dispatch = useAppDispatch();
  const theme = useAppSelector((state) => state.auth.theme);

  return (
    <Appbar.Action
      icon={theme === "light" ? "weather-sunny" : "weather-night"}
      onPress={() => dispatch(toggleThemeAction())}
    />
  );
};
